<template>
  <div class="all-workspaces-page">
    <!-- Header moderno -->
    <div class="modern-header">
      <div class="header-container">
        <!-- Breadcrumb e navegação -->
        <div class="breadcrumb-section">
          <nav class="breadcrumb">
            <button @click="$router.push('/dashboard')" class="breadcrumb-item">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
              {{ t('allWorkspaces.breadcrumb.dashboard') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ t('allWorkspaces.breadcrumb.current') }}</span>
          </nav>
        </div>

        <!-- Título e informações principais -->
        <div class="title-section">
          <div class="title-content">
            <div class="title-icon">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
              </svg>
            </div>
            <div class="title-text">
              <h1 class="main-title">{{ t('allWorkspaces.title') }}</h1>
              <p class="subtitle">{{ t('allWorkspaces.subtitle') }}</p>
            </div>
          </div>
          
          <!-- Badge do tipo de workspace -->
          <div class="workspace-badge type-dashboard">
            <div class="badge-icon">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
              </svg>
            </div>
            <span class="badge-text">{{ t('allWorkspaces.badge') }}</span>
          </div>
        </div>

        <!-- Ações do header -->
        <div class="actions-section">
          <!-- Toggle de Visualização -->
          <div class="view-toggles">
            <!-- Toggle Cards -->
            <div class="tooltip-container">
              <button 
                @click="dashboardView = 'cards'"
                class="toggle-btn"
                :class="{ 'active': dashboardView === 'cards' }"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"/>
                </svg>
              </button>
              <div class="tooltip">{{ t('allWorkspaces.viewToggle.cards') }}</div>
            </div>
            
            <!-- Toggle Estilo Workspace -->
            <div class="tooltip-container">
              <button 
                @click="dashboardView = 'workspace-style'"
                class="toggle-btn"
                :class="{ 'active': dashboardView === 'workspace-style' }"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
                </svg>
              </button>
              <div class="tooltip">{{ t('allWorkspaces.viewToggle.workspaceStyle') }}</div>
            </div>
          </div>
          
          <button 
            @click="showCreateModal = true"
            class="action-button primary"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
            {{ t('allWorkspaces.newWorkspace') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Hero de entrada -->
    <div class="hero-entry">
      <div class="hero-glow"></div>
      <div class="hero-logo">
        <div class="hero-logo-inner">BL</div>
      </div>
      <h2 class="hero-title">{{ t('allWorkspaces.hero.title') }}</h2>
      <p class="hero-subtitle">{{ t('allWorkspaces.hero.subtitle') }}</p>
      <div class="hero-stats">
        <div class="hero-stat">
          <span class="hero-stat-label">{{ t('allWorkspaces.hero.workspaces') }}</span>
          <span class="hero-stat-value">{{ totalWorkspaces }}</span>
        </div>
        <div class="hero-stat">
          <span class="hero-stat-label">{{ t('allWorkspaces.hero.withScore') }}</span>
          <span class="hero-stat-value">{{ workspacesComScore }}</span>
        </div>
        <div class="hero-stat">
          <span class="hero-stat-label">{{ t('allWorkspaces.hero.totalScore') }}</span>
          <span class="hero-stat-value">{{ formatScore(totalScoreGeral) }}</span>
        </div>
        <div class="hero-stat">
          <span class="hero-stat-label">{{ t('allWorkspaces.hero.average') }}</span>
          <span class="hero-stat-value">{{ formatScore(totalWorkspaces ? (totalScoreGeral / totalWorkspaces) : 0) }}</span>
        </div>
      </div>
    </div>

    <!-- Dashboard Compacto (Cards) -->
    <div v-if="dashboardView === 'cards'" class="dashboard-compact">
      <!-- Métricas Principais -->
      <div class="metrics-grid-compact">
        <!-- Score Total Geral -->
        <div class="metric-card-compact primary">
          <div class="metric-header-compact">
            <div class="metric-icon-compact">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
            </div>
            <div class="metric-insights-compact">
              <div class="insight-compact">
                <span class="insight-label">{{ t('allWorkspaces.metrics.withoutBonus') }}</span>
                <span class="insight-value">{{ formatScore(totalScoreSemBonus) }}</span>
              </div>
              <div class="insight-compact">
                <span class="insight-label">{{ t('allWorkspaces.metrics.bonus') }}</span>
                <span class="insight-value">{{ formatScore(totalBonus) }}</span>
              </div>
              <div class="insight-compact positive">
                <span class="insight-label">{{ t('allWorkspaces.metrics.positive') }}</span>
                <span class="insight-value">+{{ formatScore(totalPositivos) }}</span>
              </div>
              <div class="insight-compact negative">
                <span class="insight-label">{{ t('allWorkspaces.metrics.negative') }}</span>
                <span class="insight-value">{{ formatScore(totalNegativos) }}</span>
              </div>
            </div>
          </div>
          <div class="metric-content-compact">
            <div class="metric-value-compact">{{ formatScore(totalScoreGeral) }}</div>
            <div class="metric-label-compact">{{ t('allWorkspaces.metrics.totalScoreGeneral') }}</div>
            <div class="metric-subtitle-compact">{{ t('allWorkspaces.metrics.consolidatedPerformance') }}</div>
          </div>
          <div class="metric-chart-compact">
            <div class="mini-chart-compact">
              <div class="chart-bar-compact" style="height: 60%"></div>
              <div class="chart-bar-compact" style="height: 80%"></div>
              <div class="chart-bar-compact" style="height: 45%"></div>
              <div class="chart-bar-compact" style="height: 90%"></div>
              <div class="chart-bar-compact" style="height: 70%"></div>
            </div>
          </div>
        </div>

        <!-- Meta Geral Manual -->
        <div class="metric-card-compact secondary clickable" @click="showMetaModal = true">
          <div class="metric-header-compact">
            <div class="metric-icon-compact">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <div class="metric-edit-compact">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
              </svg>
            </div>
          </div>
          <div class="metric-content-compact">
            <div class="metric-value-compact">{{ formatScore(metaGeralManual) }}</div>
            <div class="metric-label-compact">{{ t('allWorkspaces.metrics.generalGoal') }}</div>
            <div class="metric-subtitle-compact">{{ t('allWorkspaces.metrics.strategicObjective') }}</div>
          </div>
          <div class="metric-progress-compact">
            <div class="progress-ring-compact">
              <svg class="w-12 h-12 transform -rotate-90">
                <circle cx="24" cy="24" r="20" stroke="currentColor" stroke-width="3" fill="transparent" opacity="0.2"/>
                <circle cx="24" cy="24" r="20" stroke="currentColor" stroke-width="3" fill="transparent" 
                        :stroke-dasharray="circumferenceCompact" 
                        :stroke-dashoffset="circumferenceCompact - (percentualMetaGeralManual / 100) * circumferenceCompact"
                        class="progress-circle-compact"/>
              </svg>
              <div class="progress-text-compact">{{ Math.round(percentualMetaGeralManual) }}%</div>
            </div>
          </div>
        </div>

        <!-- Faltante para Meta -->
        <div class="metric-card-compact" :class="totalFaltanteManual > 0 ? 'danger' : 'success'">
          <div class="metric-header-compact">
            <div class="metric-icon-compact">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <div class="metric-trend-compact" :class="totalFaltanteManual > 0 ? 'danger' : 'positive'">
              <span>{{ totalFaltanteManual > 0 ? formatScore(totalFaltanteManual) : t('allWorkspaces.metrics.goalReached') }}</span>
            </div>
          </div>
          <div class="metric-content-compact">
            <div class="metric-value-compact" :class="totalFaltanteManual > 0 ? 'danger' : 'positive'">
              {{ totalFaltanteManual > 0 ? formatScore(totalFaltanteManual) : '100%' }}
            </div>
            <div class="metric-label-compact">{{ t('allWorkspaces.metrics.remainingToGoal') }}</div>
            <div class="metric-subtitle-compact">{{ totalFaltanteManual > 0 ? t('allWorkspaces.metrics.stillNeed') : t('allWorkspaces.metrics.goalConquered') }}</div>
          </div>
          <div class="metric-chart-compact">
            <div class="progress-bar-compact">
              <div class="progress-fill-compact" 
                   :style="{ 
                     width: `${Math.min(100, Math.max(0, percentualMetaGeralManual))}%`,
                     background: `linear-gradient(90deg, ${getProgressColor(percentualMetaGeralManual)} 0%, ${getProgressColor(percentualMetaGeralManual)}80 100%)`
                   }">
                <div class="progress-shimmer-compact"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Total de Workspaces -->
        <div class="metric-card-compact info">
          <div class="metric-header-compact">
            <div class="metric-icon-compact">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
              </svg>
            </div>
            <div class="metric-badge-compact">{{ workspacesComScore }}/{{ totalWorkspaces }}</div>
          </div>
          <div class="metric-content-compact">
            <div class="metric-value-compact">{{ totalWorkspaces }}</div>
            <div class="metric-label-compact">{{ t('allWorkspaces.metrics.totalWorkspaces') }}</div>
            <div class="metric-subtitle-compact">{{ t('allWorkspaces.metrics.withScoreConfigured', { count: workspacesComScore }) }}</div>
          </div>
          <div class="metric-chart-compact">
            <div class="donut-chart-compact">
              <svg class="w-12 h-12 transform -rotate-90">
                <circle cx="24" cy="24" r="20" stroke="currentColor" stroke-width="3" fill="transparent" opacity="0.2"/>
                <circle cx="24" cy="24" r="20" stroke="currentColor" stroke-width="3" fill="transparent" 
                        :stroke-dasharray="circumferenceCompact" 
                        :stroke-dashoffset="circumferenceCompact - (workspacesComScore / totalWorkspaces) * circumferenceCompact"
                        class="progress-circle-compact"/>
              </svg>
              <div class="donut-text-compact">{{ Math.round((workspacesComScore / totalWorkspaces) * 100) }}%</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dashboard Estilo Workspace -->
    <div v-if="dashboardView === 'workspace-style'" class="dashboard-workspace-style">
      <div class="workspace-metrics-grid">
        <!-- Score Total Geral -->
        <div class="workspace-metric-card">
          <div class="card-header-premium">
            <div class="workspace-identity">
              <div class="workspace-avatar">
                <svg class="avatar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
                </svg>
              </div>
              <div class="workspace-details">
                <div class="workspace-title">{{ t('allWorkspaces.metrics.totalScoreGeneral') }}</div>
                <div class="workspace-badge">{{ t('allWorkspaces.metrics.dashboard') }}</div>
              </div>
            </div>
          </div>
          
          <div class="score-metrics-premium">
            <div class="metric-primary">
              <div class="metric-value-large">{{ formatScore(totalScoreGeral) }}</div>
              <div class="metric-label-large">{{ t('allWorkspaces.metrics.scoreTotal') }}</div>
            </div>
            <div class="metric-secondary">
              <div class="metric-value-small">{{ formatScore(totalScoreSemBonus) }}</div>
              <div class="metric-label-small">{{ t('allWorkspaces.metrics.withoutBonusUpper') }}</div>
            </div>
          </div>

          <div class="bonus-section-premium">
            <div class="bonus-header">
              <div class="bonus-title">{{ t('allWorkspaces.metrics.bonifications') }}</div>
              <div class="bonus-total">{{ formatScore(totalBonus) }}</div>
            </div>
            <div class="bonus-grid-premium">
              <div class="bonus-item-premium">
                <div class="bonus-icon">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"></path>
                  </svg>
                </div>
                <div class="bonus-content">
                  <div class="bonus-label">{{ t('allWorkspaces.metrics.complexity') }}</div>
                  <div class="bonus-value">{{ formatScore(totalPositivos) }}</div>
                </div>
              </div>
              <div class="bonus-item-premium">
                <div class="bonus-icon">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                  </svg>
                </div>
                <div class="bonus-content">
                  <div class="bonus-label">{{ t('allWorkspaces.metrics.client') }}</div>
                  <div class="bonus-value">{{ formatScore(totalNegativos) }}</div>
                </div>
              </div>
              <div class="bonus-item-premium">
                <div class="bonus-icon">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                  </svg>
                </div>
                <div class="bonus-content">
                  <div class="bonus-label">{{ t('allWorkspaces.metrics.reuse') }}</div>
                  <div class="bonus-value">{{ formatScore(totalBonus) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Meta Geral -->
        <div class="workspace-metric-card">
          <div class="card-header-premium">
            <div class="workspace-identity">
              <div class="workspace-avatar">
                <svg class="avatar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <div class="workspace-details">
                <div class="workspace-title">{{ t('allWorkspaces.metrics.generalGoal') }}</div>
                <div class="workspace-badge">{{ t('allWorkspaces.metrics.objective') }}</div>
              </div>
            </div>
            <div class="edit-btn-premium clickable" @click="showMetaModal = true">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
              </svg>
            </div>
          </div>
          
          <div class="score-metrics-premium">
            <div class="metric-primary">
              <div class="metric-value-large">{{ formatScore(metaGeralManual) }}</div>
              <div class="metric-label-large">{{ t('allWorkspaces.metrics.totalGoal') }}</div>
            </div>
            <div class="metric-secondary">
              <div class="metric-value-small">{{ Math.round(percentualMetaGeralManual) }}%</div>
              <div class="metric-label-small">{{ t('allWorkspaces.metrics.progress') }}</div>
            </div>
          </div>

          <div class="meta-progress-section">
            <div class="meta-progress-header">
              <div class="meta-progress-title">
                <div class="title-icon">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
                  </svg>
                </div>
                <span>{{ t('allWorkspaces.metrics.goalProgress') }}</span>
              </div>
              <div class="meta-progress-percentage">
                {{ Math.round(percentualMetaGeralManual) }}%
              </div>
            </div>
            
            <div class="meta-progress-content">
              <div class="progress-ring-large">
                <svg class="w-20 h-20 transform -rotate-90">
                  <circle cx="40" cy="40" r="36" stroke="currentColor" stroke-width="3" fill="transparent" opacity="0.1"/>
                  <circle cx="40" cy="40" r="36" stroke="currentColor" stroke-width="3" fill="transparent" 
                          :stroke-dasharray="circumferenceLarge" 
                          :stroke-dashoffset="circumferenceLarge - (percentualMetaGeralManual / 100) * circumferenceLarge"
                          class="progress-circle-large"/>
                </svg>
                <div class="progress-text-large">
                  <div class="progress-percentage-large">{{ Math.round(percentualMetaGeralManual) }}%</div>
                  <div class="progress-label-large">{{ t('allWorkspaces.metrics.goal') }}</div>
                </div>
              </div>
              
              <div class="meta-details">
                <div class="meta-detail-item">
                  <div class="detail-icon">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                  </div>
                  <div class="detail-content">
                    <div class="detail-label">{{ t('allWorkspaces.metrics.remaining') }}</div>
                    <div class="detail-value">{{ formatScore(totalFaltanteManual) }}</div>
                  </div>
                </div>
                
                <div class="meta-detail-item">
                  <div class="detail-icon">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
                    </svg>
                  </div>
                  <div class="detail-content">
                    <div class="detail-label">{{ t('allWorkspaces.metrics.leftPercent') }}</div>
                    <div class="detail-value">{{ Math.round(100 - percentualMetaGeralManual) }}%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filtros e Ordenação -->
    <div class="filters-section">
      <div class="filters-left">
        <div class="search-box">
          <svg class="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
          <input 
            v-model="searchTerm" 
            type="text" 
            :placeholder="t('allWorkspaces.filters.searchPlaceholder')" 
            class="search-input"
          />
        </div>
        <select v-model="sortBy" class="sort-select">
          <option value="nome">{{ t('allWorkspaces.filters.sortByName') }}</option>
          <option value="score">{{ t('allWorkspaces.filters.sortByScore') }}</option>
          <option value="meta">{{ t('allWorkspaces.filters.sortByGoal') }}</option>
          <option value="percentual">{{ t('allWorkspaces.filters.sortByPercent') }}</option>
        </select>
      </div>
      <div class="filters-right">
        <div class="view-toggle">
          <button 
            @click="viewMode = 'grid'" 
            :class="['view-btn', { active: viewMode === 'grid' }]"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
            </svg>
          </button>
          <button 
            @click="viewMode = 'list'" 
            :class="['view-btn', { active: viewMode === 'list' }]"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>{{ t('allWorkspaces.loading') }}</p>
    </div>

    <!-- Lista de Workspaces -->
    <div v-else class="workspaces-container">
      <!-- Grid View -->
      <div v-if="viewMode === 'grid'" class="workspaces-grid">
        <div 
          v-for="workspace in filteredWorkspaces" 
          :key="workspace.id"
          class="workspace-card"
        >
          <!-- Header do Card -->
          <!-- Card Header Premium -->
          <div class="card-header-premium">
            <div class="workspace-identity">
              <div class="workspace-avatar" :style="{ 
                background: workspace.fotoWorkspace ? 'transparent' : `linear-gradient(135deg, ${workspace.corWorkspace} 0%, ${workspace.corWorkspace}CC 100%)`,
                boxShadow: workspace.fotoWorkspace ? 'none' : `0 4px 20px ${workspace.corWorkspace}40`
              }">
                <img 
                  v-if="workspace.fotoWorkspace" 
                  :src="workspace.fotoWorkspace" 
                  :alt="workspace.nome"
                  class="avatar-image"
                />
                <span v-else class="avatar-icon">{{ getWorkspaceIcon(workspace.icone) }}</span>
              </div>
              <div class="workspace-details">
                <h3 class="workspace-title">{{ workspace.nome }}</h3>
                <div class="workspace-badge">{{ workspace.tipo }}</div>
              </div>
            </div>
            <button @click.stop="editWorkspaceScore(workspace)" class="edit-btn-premium">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
              </svg>
            </button>
          </div>

          <!-- Score Metrics Premium -->
          <div class="score-metrics-premium">
            <div class="metric-primary">
              <div class="metric-value-large">{{ formatScore(workspace.score?.scoreTotal) }}</div>
              <div class="metric-label-large">{{ t('allWorkspaces.metrics.scoreTotalLabel') }}</div>
            </div>
            <div class="metric-secondary">
              <div class="metric-value-small">{{ formatScore(workspace.score?.peso) }}</div>
              <div class="metric-label-small">{{ t('allWorkspaces.metrics.baseWeight') }}</div>
            </div>
          </div>

          <!-- Progress Ring -->
          <div class="progress-ring-section">
            <div class="progress-ring-container">
              <svg class="progress-ring" width="80" height="80">
                <circle cx="40" cy="40" r="32" stroke="rgba(255,255,255,0.1)" stroke-width="4" fill="transparent"/>
                <circle 
                  cx="40" cy="40" r="32" 
                  stroke="currentColor" 
                  stroke-width="4" 
                  fill="transparent"
                  :stroke-dasharray="circumference"
                  :stroke-dashoffset="circumference - (getPercentualMetaGeral(workspace) / 100) * circumference"
                  :style="{ 
                    color: getProgressColor(getPercentualMetaGeral(workspace)),
                    filter: `drop-shadow(0 0 8px ${getProgressColor(getPercentualMetaGeral(workspace))}40)`
                  }"
                  class="progress-circle"
                />
              </svg>
              <div class="progress-text">
                <span class="progress-percentage">{{ Math.round(getPercentualMetaGeral(workspace)) }}%</span>
                <span class="progress-label">{{ t('allWorkspaces.metrics.goalLabel') }}</span>
              </div>
            </div>
          </div>

          <!-- Bonificações Premium -->
          <div class="bonus-section-premium">
            <div class="bonus-header">
              <span class="bonus-title">{{ t('allWorkspaces.metrics.bonificationsTitle') }}</span>
              <div class="bonus-total">{{ formatScore((workspace.score?.bonusComplexidade || 0) + (workspace.score?.bonusCliente || 0) + (workspace.score?.bonusReaproveitamento || 0)) }}</div>
            </div>
            <div class="bonus-grid-premium">
              <div class="bonus-item-premium" :class="getBonusClass(workspace.score?.bonusComplexidade)">
                <div class="bonus-icon">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                  </svg>
                </div>
                <div class="bonus-content">
                  <span class="bonus-label">{{ t('allWorkspaces.metrics.complexityLabel') }}</span>
                  <span class="bonus-value">{{ formatScore(workspace.score?.bonusComplexidade) }}</span>
                </div>
              </div>
              <div class="bonus-item-premium" :class="getBonusClass(workspace.score?.bonusCliente)">
                <div class="bonus-icon">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                  </svg>
                </div>
                <div class="bonus-content">
                  <span class="bonus-label">{{ t('allWorkspaces.metrics.clientLabel') }}</span>
                  <span class="bonus-value">{{ formatScore(workspace.score?.bonusCliente) }}</span>
                </div>
              </div>
              <div class="bonus-item-premium" :class="getBonusClass(workspace.score?.bonusReaproveitamento)">
                <div class="bonus-icon">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                  </svg>
                </div>
                <div class="bonus-content">
                  <span class="bonus-label">{{ t('allWorkspaces.metrics.reuseLabel') }}</span>
                  <span class="bonus-value">{{ formatScore(workspace.score?.bonusReaproveitamento) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- List View -->
      <div v-else class="workspaces-list">
        <div class="list-header">
          <div class="list-col name">{{ t('allWorkspaces.list.workspace') }}</div>
          <div class="list-col peso">{{ t('allWorkspaces.list.weight') }}</div>
          <div class="list-col total">{{ t('allWorkspaces.list.scoreTotal') }}</div>
          <div class="list-col percentual">{{ t('allWorkspaces.metrics.percentGeneralGoal') }}</div>
          <div class="list-col bonus">{{ t('allWorkspaces.list.bonifications') }}</div>
          <div class="list-col actions">{{ t('allWorkspaces.list.actions') }}</div>
        </div>
        <div 
          v-for="workspace in filteredWorkspaces" 
          :key="workspace.id"
          class="list-row"
          @click="openWorkspace(workspace)"
        >
          <div class="list-col name">
            <div class="workspace-info">
              <div class="workspace-icon" :style="{ backgroundColor: workspace.corWorkspace }">
                <span>{{ getWorkspaceIcon(workspace.icone) }}</span>
              </div>
              <div>
                <div class="workspace-name">{{ workspace.nome }}</div>
                <div class="workspace-type">{{ workspace.tipo }}</div>
              </div>
            </div>
          </div>
          <div class="list-col peso">
            <span class="score-value">{{ formatScore(workspace.score?.peso) }}</span>
          </div>
          <div class="list-col total">
            <span class="score-value total">{{ formatScore(workspace.score?.scoreTotal) }}</span>
          </div>
          <div class="list-col percentual">
            <span class="score-value percentage" :class="getPercentageClass(getPercentualMetaGeral(workspace))">
              {{ formatPercentage(getPercentualMetaGeral(workspace)) }}
            </span>
          </div>
          <div class="list-col bonus">
            <div class="bonus-mini">
              <span>{{ t('allWorkspaces.list.complexityShort') }}: {{ formatScore(workspace.score?.bonusComplexidade) }}</span>
              <span>{{ t('allWorkspaces.list.clientShort') }}: {{ formatScore(workspace.score?.bonusCliente) }}</span>
              <span>{{ t('allWorkspaces.list.reuseShort') }}: {{ formatScore(workspace.score?.bonusReaproveitamento) }}</span>
            </div>
          </div>
          <div class="list-col actions">
            <button @click.stop="editWorkspaceScore(workspace)" class="action-btn edit">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Edição de Score -->
    <EditWorkspaceScoreModal 
      v-if="showEditModal"
      :workspace="selectedWorkspace"
      :metaGeralManual="metaGeralManual"
      @close="showEditModal = false"
      @updated="handleScoreUpdated"
    />

    <!-- Modal de Criação de Workspace -->
    <CreateWorkspaceModal 
      v-if="showCreateModal"
      @close="showCreateModal = false"
      @created="handleWorkspaceCreated"
    />

    <!-- Modal de Configuração da Meta Geral -->
    <div v-if="showMetaModal" class="modal-overlay" @click="showMetaModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h2 class="modal-title">{{ t('allWorkspaces.metaModal.title') }}</h2>
          <button @click="showMetaModal = false" class="modal-close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        <form @submit.prevent="saveMetaGeral" class="modal-form">
          <div class="form-group">
            <label class="form-label">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              {{ t('allWorkspaces.metaModal.manualGoal') }}
            </label>
            <div class="input-group">
              <input
                v-model.number="metaGeralForm.valor"
                type="number"
                step="0.1"
                min="0"
                max="9999.9"
                class="form-input"
                placeholder="0.0"
                required
              />
              <div class="input-help">
                <span>{{ t('allWorkspaces.metaModal.help') }}</span>
              </div>
            </div>
          </div>

          <!-- Preview -->
          <div class="preview-section">
            <h3 class="section-title">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
              </svg>
              {{ t('allWorkspaces.metaModal.previewTitle') }}
            </h3>
            
            <div class="preview-grid">
              <div class="preview-item">
                <span class="preview-label">{{ t('allWorkspaces.metaModal.currentScore') }}</span>
                <span class="preview-value">{{ formatScore(totalScoreGeral) }}</span>
              </div>
              <div class="preview-item">
                <span class="preview-label">{{ t('allWorkspaces.metaModal.manualGoalPreview') }}</span>
                <span class="preview-value meta">{{ formatScore(metaGeralForm.valor) }}</span>
              </div>
              <div class="preview-item">
                <span class="preview-label">{{ t('allWorkspaces.metaModal.percentOfGoal') }}</span>
                <span class="preview-value percentage" :class="getPercentageClass(percentualPreview)">
                  {{ formatPercentage(percentualPreview) }}
                </span>
              </div>
              <div class="preview-item">
                <span class="preview-label">{{ t('allWorkspaces.metaModal.remaining') }}</span>
                <span class="preview-value">{{ formatScore(faltantePreview) }}</span>
              </div>
            </div>

            <!-- Barra de Progresso -->
            <div class="progress-section">
              <div class="progress-bar">
                <div 
                  class="progress-fill" 
                  :style="{ 
                    width: `${Math.min(100, Math.max(0, percentualPreview))}%`,
                    backgroundColor: getProgressColor(percentualPreview)
                  }"
                ></div>
              </div>
              <div class="progress-text">
                <span>{{ t('allWorkspaces.metaModal.remainingToReach', { value: formatScore(faltantePreview) }) }}</span>
              </div>
            </div>
          </div>
          
          <!-- Botões -->
          <div class="modal-actions">
            <button type="button" @click="showMetaModal = false" class="btn-secondary">
              {{ t('allWorkspaces.common.cancel') }}
            </button>
            <button type="submit" class="btn-primary" :disabled="loading">
              <span v-if="loading" class="loading-spinner"></span>
              {{ loading ? t('allWorkspaces.metaModal.saving') : t('allWorkspaces.metaModal.saveGoal') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useGlobalWorkspaces } from '../composables/useGlobalWorkspaces'
import { useAuthStore } from '../stores/auth'
import api from '../services/api'
import EditWorkspaceScoreModal from '../components/EditWorkspaceScoreModal.vue'
import CreateWorkspaceModal from '../components/CreateWorkspaceModal.vue'
import Swal from 'sweetalert2'

const { t } = useI18n()
const router = useRouter()
const authStore = useAuthStore()
const { workspaces, loadWorkspaces } = useGlobalWorkspaces()

// Estado da página
const loading = ref(true)
const searchTerm = ref('')
const sortBy = ref('nome')
const viewMode = ref('grid')
const showEditModal = ref(false)
const showCreateModal = ref(false)
const showMetaModal = ref(false)
const dashboardView = ref('cards') // 'cards' ou 'workspace-style'
const selectedWorkspace = ref(null)

// Meta geral manual
const metaGeralManual = ref(0)
const metaGeralForm = ref({
  valor: 0
})

// Dados dos scores
const workspaceScores = ref([])

// Computed
const totalWorkspaces = computed(() => {
  return workspaces.value.length
})

const totalScoreGeral = computed(() => {
  return filteredWorkspaces.value.reduce((total, workspace) => {
    return total + (parseFloat(workspace.score?.scoreTotal) || 0)
  }, 0)
})



const workspacesComScore = computed(() => {
  return filteredWorkspaces.value.filter(workspace => 
    workspace.score && (
      parseFloat(workspace.score.peso) !== 0 ||
      parseFloat(workspace.score.bonusComplexidade) !== 0 ||
      parseFloat(workspace.score.bonusCliente) !== 0 ||
      parseFloat(workspace.score.bonusReaproveitamento) !== 0
    )
  ).length
})


// Computed para meta geral manual
const percentualMetaGeralManual = computed(() => {
  if (metaGeralManual.value === 0) return 0
  return (totalScoreGeral.value / metaGeralManual.value) * 100
})

const totalFaltanteManual = computed(() => {
  return Math.max(0, metaGeralManual.value - totalScoreGeral.value)
})

// Computed para preview no modal
const percentualPreview = computed(() => {
  if (metaGeralForm.value.valor === 0) return 0
  return (totalScoreGeral.value / metaGeralForm.value.valor) * 100
})

const faltantePreview = computed(() => {
  return Math.max(0, metaGeralForm.value.valor - totalScoreGeral.value)
})

const filteredWorkspaces = computed(() => {
  let filtered = workspaces.value.map(workspace => {
    const score = workspaceScores.value.find(s => s.workspaceId === workspace.id)
    return {
      ...workspace,
      score: score || {
        peso: 0,
        bonusComplexidade: 0,
        bonusCliente: 0,
        bonusReaproveitamento: 0,
        metaPeso: 0,
        scoreTotal: 0,
        scoreSemBonus: 0,
        percentualMeta: 0,
        faltanteParaMeta: 0
      }
    }
  })

  // Filtro por busca
  if (searchTerm.value) {
    const term = searchTerm.value.toLowerCase()
    filtered = filtered.filter(workspace => 
      workspace.nome.toLowerCase().includes(term) ||
      workspace.tipo.toLowerCase().includes(term)
    )
  }

  // Ordenação
  filtered.sort((a, b) => {
    switch (sortBy.value) {
      case 'score':
        return (b.score?.scoreTotal || 0) - (a.score?.scoreTotal || 0)
      case 'meta':
        return (b.score?.metaPeso || 0) - (a.score?.metaPeso || 0)
      case 'percentual':
        return (b.score?.percentualMeta || 0) - (a.score?.percentualMeta || 0)
      default:
        return a.nome.localeCompare(b.nome)
    }
  })

  return filtered
})

// Métodos
const loadWorkspaceScores = async () => {
  try {
    const response = await api.get('/workspace-scores')
    workspaceScores.value = response.data
  } catch (error) {
    console.error('Erro ao carregar scores:', error)
  }
}

const loadMetaGeral = async () => {
  try {
    const response = await api.get(`/usuario-meta-geral/usuario/${authStore.user.id}/valor`)
    metaGeralManual.value = parseFloat(response.data.metaGeral || 0)
    metaGeralForm.value.valor = metaGeralManual.value
  } catch (error) {
    if (error.response?.status === 404) {
      // Meta não existe, manter valor padrão
      console.log('Meta geral não encontrada, usando valor padrão')
    } else {
      console.error('Erro ao carregar meta geral:', error)
    }
  }
}

const openWorkspace = (workspace) => {
  router.push(`/workspace/${workspace.id}/kanban`)
}

const editWorkspaceScore = (workspace) => {
  selectedWorkspace.value = workspace
  showEditModal.value = true
}

const handleScoreUpdated = (updatedScore) => {
  const index = workspaceScores.value.findIndex(s => s.workspaceId === updatedScore.workspaceId)
  if (index >= 0) {
    workspaceScores.value[index] = updatedScore
  } else {
    workspaceScores.value.push(updatedScore)
  }
  showEditModal.value = false
}

const handleWorkspaceCreated = (newWorkspace) => {
  loadWorkspaces()
  showCreateModal.value = false
}

const saveMetaGeral = async () => {
  try {
    loading.value = true
    
    const requestData = {
      metaGeral: metaGeralForm.value.valor
    }
    
    console.log('Salvando meta geral:', requestData)
    
    const response = await api.put(`/usuario-meta-geral/usuario/${authStore.user.id}`, requestData)
    
    console.log('Meta geral salva com sucesso:', response.data)
    
    metaGeralManual.value = metaGeralForm.value.valor
    showMetaModal.value = false
    
    // Mostrar mensagem de sucesso
    await Swal.fire({
      icon: 'success',
      title: t('allWorkspaces.swal.goalSavedTitle'),
      text: t('allWorkspaces.swal.goalSavedText', { value: formatScore(metaGeralManual.value) }),
      timer: 2000,
      showConfirmButton: false
    })
    
  } catch (error) {
    console.error('Erro ao salvar meta geral:', error)
    await Swal.fire({
      icon: 'error',
      title: t('allWorkspaces.swal.saveGoalErrorTitle'),
      text: error.response?.data?.message || t('allWorkspaces.swal.saveGoalErrorFallback'),
      confirmButtonText: t('allWorkspaces.common.ok')
    })
  } finally {
    loading.value = false
  }
}

// Utilitários
const formatScore = (value) => {
  if (value === null || value === undefined) return '0.0'
  return parseFloat(value).toFixed(1)
}

const formatPercentage = (value) => {
  if (value === null || value === undefined) return '0.0%'
  return `${parseFloat(value).toFixed(1)}%`
}

const getWorkspaceIcon = (icone) => {
  const icons = {
    'mail': '📧',
    'briefcase': '💼',
    'users': '👥',
    'chart': '📊',
    'settings': '⚙️',
    'star': '⭐',
    'heart': '❤️',
    'lightning': '⚡'
  }
  return icons[icone] || '📁'
}

const getPercentageClass = (percentual) => {
  const value = parseFloat(percentual || 0)
  if (value >= 100) return 'success'
  if (value >= 75) return 'warning'
  return 'danger'
}

const getProgressColor = (percentual) => {
  const value = parseFloat(percentual || 0)
  if (value >= 100) return '#10b981' // green
  if (value >= 75) return '#f59e0b'  // yellow
  return '#ef4444' // red
}

const getBonusClass = (bonus) => {
  const value = parseFloat(bonus || 0)
  if (value > 0) return 'positive'
  if (value < 0) return 'negative'
  return 'neutral'
}

// Funções utilitárias para percentuais da meta geral
const getPercentualMetaGeral = (workspace) => {
  if (metaGeralManual.value === 0) return 0
  const scoreTotal = parseFloat(workspace.score?.scoreTotal || 0)
  return (scoreTotal / metaGeralManual.value) * 100
}

const getFaltanteMetaGeral = (workspace) => {
  const scoreTotal = parseFloat(workspace.score?.scoreTotal || 0)
  return Math.max(0, metaGeralManual.value - scoreTotal)
}

// Computed para gráficos
const circumference = computed(() => 2 * Math.PI * 28) // raio 28
const circumferenceCompact = computed(() => 2 * Math.PI * 20) // raio 20 para dashboard compacto
const circumferenceLarge = computed(() => 2 * Math.PI * 36) // raio 36 para anel grande

// Computed para insights do score
const totalScoreSemBonus = computed(() => {
  return filteredWorkspaces.value.reduce((total, workspace) => {
    return total + (parseFloat(workspace.score?.peso) || 0)
  }, 0)
})

const totalBonus = computed(() => {
  return filteredWorkspaces.value.reduce((total, workspace) => {
    const bonusComplexidade = parseFloat(workspace.score?.bonusComplexidade) || 0
    const bonusCliente = parseFloat(workspace.score?.bonusCliente) || 0
    const bonusReaproveitamento = parseFloat(workspace.score?.bonusReaproveitamento) || 0
    return total + bonusComplexidade + bonusCliente + bonusReaproveitamento
  }, 0)
})

const totalPositivos = computed(() => {
  return filteredWorkspaces.value.reduce((total, workspace) => {
    const scoreTotal = parseFloat(workspace.score?.scoreTotal) || 0
    return total + Math.max(0, scoreTotal)
  }, 0)
})

const totalNegativos = computed(() => {
  return filteredWorkspaces.value.reduce((total, workspace) => {
    const scoreTotal = parseFloat(workspace.score?.scoreTotal) || 0
    return total + Math.min(0, scoreTotal)
  }, 0)
})

// Lifecycle
onMounted(async () => {
  loading.value = true
  
  await loadWorkspaces()
  await loadWorkspaceScores()
  await loadMetaGeral()
  
  loading.value = false
})
</script>

<style scoped>
.all-workspaces-page {
  width: 100%;
  min-height: calc(100vh - 64px);
  background-color: var(--bg-primary);
}

/* Header */

/* Header moderno */
.modern-header {
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-primary);
  padding: 24px 0;
  margin-bottom: 32px;
}

.hero-entry {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  padding: 48px 24px 36px;
  margin: 8px 24px 32px;
  background: radial-gradient(circle at top, rgba(99, 102, 241, 0.18), transparent 60%),
              linear-gradient(180deg, var(--bg-secondary), var(--bg-primary));
  border: 1px solid var(--border-primary);
  text-align: center;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
}

.hero-glow {
  position: absolute;
  inset: -80px;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.16), transparent 55%);
  pointer-events: none;
}

.hero-logo {
  width: 140px;
  height: 140px;
  border-radius: 999px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, var(--primary), rgba(99, 102, 241, 0.6));
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 18px 40px rgba(99, 102, 241, 0.45);
  position: relative;
  z-index: 1;
}

.hero-logo-inner {
  width: 120px;
  height: 120px;
  border-radius: 999px;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.65), rgba(15, 23, 42, 0.25));
  color: #fff;
  font-weight: 800;
  font-size: 36px;
  letter-spacing: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.hero-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 6px;
  position: relative;
  z-index: 1;
}

.hero-subtitle {
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
}

.hero-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  position: relative;
  z-index: 1;
}

.hero-stat {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 14px;
  padding: 12px 14px;
  text-align: center;
}

.hero-stat-label {
  font-size: 0.7rem;
  color: var(--text-secondary);
  display: block;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.hero-stat-value {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
}

@media (max-width: 1024px) {
  .hero-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .hero-logo {
    width: 110px;
    height: 110px;
  }
  .hero-logo-inner {
    width: 92px;
    height: 92px;
    font-size: 28px;
  }
}

.header-container {
  width: 100%;
  padding: 0 24px;
}

/* Breadcrumb */
.breadcrumb-section {
  margin-bottom: 16px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--text-secondary);
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.2s ease;
  font-size: 14px;
}

.breadcrumb-item:hover {
  color: var(--primary);
}

.breadcrumb-separator {
  color: var(--text-tertiary);
  font-size: 12px;
}

.breadcrumb-current {
  color: var(--text-primary);
  font-weight: 500;
}

/* Título e informações principais */
.title-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
}

.title-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.title-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.title-text {
  flex: 1;
}

.main-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 4px 0;
  line-height: 1.2;
}

.subtitle {
  font-size: 16px;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.4;
}

/* Badge do workspace */
.workspace-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid;
  transition: all 0.2s ease;
}

.workspace-badge.type-dashboard {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
}

.workspace-badge.type-crm {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border-color: #10b981;
}

.workspace-badge.type-tarefas {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  border-color: #6366f1;
}

.badge-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-text {
  font-weight: 600;
}

/* Ações do header */
.actions-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.view-toggles {
  display: flex;
  align-items: center;
  gap: 4px;
  background: var(--bg-secondary);
  padding: 4px;
  border-radius: 8px;
  border: 1px solid var(--border-primary);
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.toggle-btn:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.toggle-btn.active {
  background: var(--primary);
  color: white;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
}

:global(body.tema_clara) .view-toggles,
:global(html.tema_clara) .view-toggles,
:global(.tema_clara) .view-toggles {
  background: #f8fafc;
  border-color: #e2e8f0;
}

:global(body.tema_clara) .toggle-btn,
:global(html.tema_clara) .toggle-btn,
:global(.tema_clara) .toggle-btn {
  color: #475569;
}

:global(body.tema_clara) .toggle-btn svg,
:global(html.tema_clara) .toggle-btn svg,
:global(.tema_clara) .toggle-btn svg {
  stroke: #334155;
}

:global(body.tema_clara) .toggle-btn.active,
:global(html.tema_clara) .toggle-btn.active,
:global(.tema_clara) .toggle-btn.active {
  background: #1d4ed8;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(29, 78, 216, 0.35);
}

:global(body.tema_clara) .toggle-btn.active svg,
:global(html.tema_clara) .toggle-btn.active svg,
:global(.tema_clara) .toggle-btn.active svg {
  stroke: #ffffff;
}

:global(body.tema_clara) .all-workspaces-page .view-toggles,
:global(html.tema_clara) .all-workspaces-page .view-toggles,
:global(.tema_clara) .all-workspaces-page .view-toggles {
  background: #ffffff !important;
  border-color: #cbd5f5 !important;
}

:global(body.tema_clara) .all-workspaces-page .toggle-btn,
:global(html.tema_clara) .all-workspaces-page .toggle-btn,
:global(.tema_clara) .all-workspaces-page .toggle-btn {
  color: #0f172a !important;
}

:global(body.tema_clara) .all-workspaces-page .toggle-btn.active,
:global(html.tema_clara) .all-workspaces-page .toggle-btn.active,
:global(.tema_clara) .all-workspaces-page .toggle-btn.active {
  background: #1d4ed8 !important;
  color: #ffffff !important;
}

:global(body.tema_clara) .all-workspaces-page .toggle-btn.active svg,
:global(html.tema_clara) .all-workspaces-page .toggle-btn.active svg,
:global(.tema_clara) .all-workspaces-page .toggle-btn.active svg {
  stroke: #ffffff !important;
}

/* Tooltip */
.tooltip {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: var(--bg-primary);
  color: var(--text-primary);
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  border: 1px solid var(--border-primary);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 1000;
  margin-top: 8px;
}

.tooltip::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-bottom-color: var(--bg-primary);
}

.tooltip-container:hover .tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(2px);
}

/* Botões de ação */
.action-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid;
  text-decoration: none;
}

.action-button.secondary {
  background: var(--bg-secondary);
  color: var(--text-primary);
  border-color: var(--border-primary);
}

.action-button.secondary:hover {
  background: var(--bg-tertiary);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.action-button.primary {
  background: var(--primary);
  color: white;
  border-color: var(--primary);
}

:global(body.tema_clara) .action-button.primary,
:global(html.tema_clara) .action-button.primary,
:global(.tema_clara) .action-button.primary {
  background: #1d4ed8 !important;
  border-color: #1d4ed8 !important;
  color: #ffffff !important;
}

:global(body.tema_clara) .all-workspaces-page .action-button.primary,
:global(html.tema_clara) .all-workspaces-page .action-button.primary,
:global(.tema_clara) .all-workspaces-page .action-button.primary {
  background: #1d4ed8 !important;
  border-color: #1d4ed8 !important;
  color: #ffffff !important;
}

:global(.tema_clara) .all-workspaces-page .action-button.primary,
:global(.tema_clara) .all-workspaces-page .actions-section .action-button.primary {
  background: #1d4ed8 !important;
  border-color: #1d4ed8 !important;
  color: #ffffff !important;
}

.action-button.primary:hover {
  background: var(--primary-dark);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

:global(body.tema_clara) .action-button.primary:hover,
:global(html.tema_clara) .action-button.primary:hover,
:global(.tema_clara) .action-button.primary:hover {
  background: #1e40af !important;
  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.35);
}

:global(body.tema_clara) .all-workspaces-page .action-button.primary:hover,
:global(html.tema_clara) .all-workspaces-page .action-button.primary:hover,
:global(.tema_clara) .all-workspaces-page .action-button.primary:hover {
  background: #1e40af !important;
}

:global(body.tema_clara) .all-workspaces-page .action-button.primary svg,
:global(html.tema_clara) .all-workspaces-page .action-button.primary svg,
:global(.tema_clara) .all-workspaces-page .action-button.primary svg {
  stroke: #ffffff !important;
}

:global(.tema_clara) .all-workspaces-page .action-button.primary:hover,
:global(.tema_clara) .all-workspaces-page .actions-section .action-button.primary:hover {
  background: #1e40af !important;
  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.35);
}

:global(body.tema_clara) .action-button.primary svg,
:global(html.tema_clara) .action-button.primary svg,
:global(.tema_clara) .action-button.primary svg {
  stroke: #ffffff !important;
}

.action-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

/* Dashboard Compacto - Seguindo padrão dos cards dos workspaces */
.dashboard-compact {
  margin-bottom: 32px;
}

/* Dashboard Estilo Workspace */
.dashboard-workspace-style {
  margin-bottom: 32px;
}

.workspace-metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
  width: 100%;
  padding: 0 24px;
}

.workspace-metric-card {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-primary) 100%);
  border: 1px solid var(--border-primary);
  border-radius: 20px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.workspace-metric-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--primary) 0%, var(--primary-dark) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.workspace-metric-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  border-color: var(--primary);
}

.workspace-metric-card:hover::before {
  opacity: 1;
}

.metrics-grid-compact {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
  width: 100%;
  padding: 0 24px;
}

.metric-card-compact {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-primary) 100%);
  border: 1px solid var(--border-primary);
  border-radius: 16px;
  padding: 20px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.metric-card-compact::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--primary) 0%, var(--primary-dark) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.metric-card-compact:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border-color: var(--primary);
}

.metric-card-compact:hover::before {
  opacity: 1;
}

.metric-card-compact.primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
}

.metric-card-compact.secondary {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  border-color: #f093fb;
}

.metric-card-compact.success {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  border-color: #4facfe;
}

.metric-card-compact.info {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  color: white;
  border-color: #43e97b;
}

.metric-card-compact.danger {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  color: white;
  border-color: #ff6b6b;
}

.metric-card-compact.clickable {
  cursor: pointer;
}

.metric-card-compact.clickable:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.metric-header-compact {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.metric-icon-compact {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.metric-trend-compact {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 6px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.metric-trend-compact.positive {
  color: #10b981;
  background: rgba(16, 185, 129, 0.2);
}

.metric-trend-compact.warning {
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.2);
}

.metric-trend-compact.danger {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.3);
}

.metric-edit-compact {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
}

.metric-edit-compact:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.metric-badge-compact {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 6px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.metric-content-compact {
  margin-bottom: 16px;
}

.metric-value-compact {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 4px;
  line-height: 1.1;
  background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.8) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-value-compact.warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-value-compact.positive {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-value-compact.danger {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-label-compact {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
  opacity: 0.9;
}

.metric-subtitle-compact {
  font-size: 11px;
  opacity: 0.7;
  font-weight: 500;
}

.metric-chart-compact {
  height: 50px;
  display: flex;
  align-items: end;
}

.mini-chart-compact {
  display: flex;
  align-items: end;
  gap: 2px;
  height: 100%;
  width: 100%;
}

.chart-bar-compact {
  flex: 1;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px 2px 0 0;
  animation: chartGrow 0.8s ease-out;
  animation-fill-mode: both;
}

.chart-bar-compact:nth-child(1) { animation-delay: 0.1s; }
.chart-bar-compact:nth-child(2) { animation-delay: 0.2s; }
.chart-bar-compact:nth-child(3) { animation-delay: 0.3s; }
.chart-bar-compact:nth-child(4) { animation-delay: 0.4s; }
.chart-bar-compact:nth-child(5) { animation-delay: 0.5s; }

@keyframes chartGrow {
  from { height: 0; }
  to { height: var(--height, 50%); }
}

.metric-progress-compact {
  display: flex;
  justify-content: center;
  align-items: center;
}

.progress-ring-compact {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-circle-compact {
  transition: stroke-dashoffset 1s ease-in-out;
  stroke-linecap: round;
}

.progress-text-compact {
  position: absolute;
  font-size: 12px;
  font-weight: 700;
  color: white;
}

.progress-bar-compact {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  overflow: hidden;
  position: relative;
}

.progress-fill-compact {
  height: 100%;
  border-radius: 3px;
  position: relative;
  transition: width 1s ease-in-out;
}

.progress-shimmer-compact {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.donut-chart-compact {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.donut-text-compact {
  position: absolute;
  font-size: 12px;
  font-weight: 700;
  color: white;
}

.metric-insights-compact {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 80px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 6px;
  backdrop-filter: blur(10px);
}

.insight-compact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 9px;
  line-height: 1.2;
  padding: 1px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease;
}

.insight-compact:last-child {
  border-bottom: none;
}

.insight-compact:hover {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  padding: 1px 3px;
  margin: 0 -3px;
}

.insight-compact.positive {
  border-left: 2px solid #10b981;
  padding-left: 4px;
}

.insight-compact.negative {
  border-left: 2px solid #ef4444;
  padding-left: 4px;
}

.insight-compact.positive .insight-value {
  color: #10b981;
  font-weight: 700;
  text-shadow: 0 0 6px rgba(16, 185, 129, 0.3);
}

.insight-compact.negative .insight-value {
  color: #ef4444;
  font-weight: 700;
  text-shadow: 0 0 6px rgba(239, 68, 68, 0.3);
}

/* Seção de Progresso da Meta - Design Elegante */
.meta-progress-section {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 20px;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
}

.meta-progress-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 50%, #ec4899 100%);
  opacity: 0.8;
}

.meta-progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.meta-progress-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 600;
}

.title-icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.meta-progress-percentage {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.meta-progress-content {
  display: flex;
  align-items: center;
  gap: 24px;
}

.progress-ring-large {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.progress-circle-large {
  transition: stroke-dashoffset 1.5s ease-in-out;
  stroke-linecap: round;
  stroke: url(#progressGradient);
}

.progress-text-large {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.progress-percentage-large {
  font-size: 16px;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1;
}

.progress-label-large {
  font-size: 10px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 2px;
}

.meta-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
}

.meta-detail-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.meta-detail-item:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.15);
  transform: translateY(-1px);
}

.detail-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(139, 92, 246, 0.2) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6366f1;
  flex-shrink: 0;
}

.detail-content {
  flex: 1;
}

.detail-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.detail-value {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
}

/* Gradiente SVG para o anel de progresso */
.progress-ring-large svg {
  filter: drop-shadow(0 0 8px rgba(99, 102, 241, 0.3));
}

/* Definição do gradiente SVG */
.progress-ring-large svg defs {
  display: none;
}

.progress-ring-large svg::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: conic-gradient(from 0deg, #6366f1 0%, #8b5cf6 50%, #ec4899 100%);
  border-radius: 50%;
  z-index: -1;
}

.metric-card-premium {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-primary) 100%);
  border: 1px solid var(--border-primary);
  border-radius: 20px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
}

.metric-card-premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--primary) 0%, var(--primary-dark) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.metric-card-premium:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border-color: var(--primary);
}

.metric-card-premium:hover::before {
  opacity: 1;
}

.metric-card-premium.primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
}

.metric-card-premium.secondary {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  border-color: #f093fb;
}

.metric-card-premium.success {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  border-color: #4facfe;
}

.metric-card-premium.info {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  color: white;
  border-color: #43e97b;
}

.metric-card-premium.danger {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  color: white;
  border-color: #ff6b6b;
}

.metric-card-premium.clickable {
  cursor: pointer;
}

.metric-card-premium.clickable:hover {
  transform: translateY(-12px) scale(1.03);
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.2);
}

.metric-header-premium {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.metric-icon-premium {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  position: relative;
  overflow: hidden;
}

.metric-icon-premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%);
  border-radius: 16px;
}

.metric-trend-premium {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.metric-trend-premium.positive {
  color: #10b981;
  background: rgba(16, 185, 129, 0.2);
}

.metric-trend-premium.warning {
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.2);
}

.metric-trend-premium.danger {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.3);
}

.metric-edit-premium {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.metric-edit-premium:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.metric-badge-premium {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.metric-content-premium {
  margin-bottom: 20px;
}

.metric-value-premium {
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 4px;
  line-height: 1.1;
  background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.8) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-value-premium.warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-value-premium.positive {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-value-premium.danger {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-label-premium {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
  opacity: 0.9;
}

.metric-subtitle-premium {
  font-size: 12px;
  opacity: 0.7;
  font-weight: 500;
}

.metric-chart-premium {
  height: 60px;
  display: flex;
  align-items: end;
}

.mini-chart-premium {
  display: flex;
  align-items: end;
  gap: 3px;
  height: 100%;
  width: 100%;
}

.chart-bar-premium {
  flex: 1;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px 2px 0 0;
  animation: chartGrow 0.8s ease-out;
  animation-fill-mode: both;
}

.chart-bar-premium:nth-child(1) { animation-delay: 0.1s; }
.chart-bar-premium:nth-child(2) { animation-delay: 0.2s; }
.chart-bar-premium:nth-child(3) { animation-delay: 0.3s; }
.chart-bar-premium:nth-child(4) { animation-delay: 0.4s; }
.chart-bar-premium:nth-child(5) { animation-delay: 0.5s; }

@keyframes chartGrow {
  from { height: 0; }
  to { height: var(--height, 50%); }
}

.metric-progress-premium {
  display: flex;
  justify-content: center;
  align-items: center;
}

.progress-ring-premium {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-circle-premium {
  transition: stroke-dashoffset 1s ease-in-out;
  stroke-linecap: round;
}

.progress-text-premium {
  position: absolute;
  font-size: 14px;
  font-weight: 700;
  color: white;
}

.progress-bar-premium {
  width: 100%;
  height: 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.progress-fill-premium {
  height: 100%;
  border-radius: 4px;
  position: relative;
  transition: width 1s ease-in-out;
}

.progress-shimmer-premium {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.donut-chart-premium {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.donut-text-premium {
  position: absolute;
  font-size: 14px;
  font-weight: 700;
  color: white;
}

.metric-insights-premium {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 90px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 8px;
  backdrop-filter: blur(10px);
}

.insight-item-premium {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  line-height: 1.3;
  padding: 2px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease;
}

.insight-item-premium:last-child {
  border-bottom: none;
}

.insight-item-premium:hover {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  padding: 2px 4px;
  margin: 0 -4px;
}

.insight-item-premium.positive {
  border-left: 2px solid #10b981;
  padding-left: 6px;
}

.insight-item-premium.negative {
  border-left: 2px solid #ef4444;
  padding-left: 6px;
}

.insight-item-premium.positive .insight-value {
  color: #10b981;
  font-weight: 700;
  text-shadow: 0 0 8px rgba(16, 185, 129, 0.3);
}

.insight-item-premium.negative .insight-value {
  color: #ef4444;
  font-weight: 700;
  text-shadow: 0 0 8px rgba(239, 68, 68, 0.3);
}

.metric-card {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-primary) 100%);
  border: 1px solid var(--border-primary);
  border-radius: 20px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
}

.metric-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--primary) 0%, var(--primary-dark) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.metric-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border-color: var(--primary);
}

.metric-card:hover::before {
  opacity: 1;
}

.metric-card.primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
}

.metric-card.secondary {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  border-color: #f093fb;
}

.metric-card.success {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  border-color: #4facfe;
}

.metric-card.info {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  color: white;
  border-color: #43e97b;
}

.metric-card.danger {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  color: white;
  border-color: #ff6b6b;
}

.metric-card.clickable {
  cursor: pointer;
}

.metric-card.clickable:hover {
  transform: translateY(-12px) scale(1.03);
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.2);
}

.metric-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.metric-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.metric-trend {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.metric-trend.positive {
  color: #10b981;
  background: rgba(16, 185, 129, 0.2);
}

.metric-trend.warning {
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.2);
}

.metric-trend.danger {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.3);
}

.metric-edit {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.metric-edit:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.metric-badge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.metric-insights {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 90px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 8px;
  backdrop-filter: blur(10px);
}

.insight-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  line-height: 1.3;
  padding: 2px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease;
}

.insight-item:last-child {
  border-bottom: none;
}

.insight-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  padding: 2px 4px;
  margin: 0 -4px;
}

.insight-item.positive {
  border-left: 2px solid #10b981;
  padding-left: 6px;
}

.insight-item.negative {
  border-left: 2px solid #ef4444;
  padding-left: 6px;
}

.insight-item.positive .insight-value {
  color: #10b981;
  font-weight: 700;
  text-shadow: 0 0 8px rgba(16, 185, 129, 0.3);
}

.insight-item.negative .insight-value {
  color: #ef4444;
  font-weight: 700;
  text-shadow: 0 0 8px rgba(239, 68, 68, 0.3);
}

.insight-label {
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.insight-value {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
  font-size: 11px;
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
}

.metric-content {
  margin-bottom: 16px;
}

.metric-value {
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 4px;
  line-height: 1.1;
  background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.8) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-value.warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-value.positive {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-value.danger {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-label {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
  opacity: 0.9;
}

.metric-subtitle {
  font-size: 12px;
  opacity: 0.7;
  font-weight: 500;
}

.metric-chart {
  height: 60px;
  display: flex;
  align-items: end;
}

.mini-chart {
  display: flex;
  align-items: end;
  gap: 3px;
  height: 100%;
  width: 100%;
}

.chart-bar {
  flex: 1;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px 2px 0 0;
  animation: chartGrow 0.8s ease-out;
  animation-fill-mode: both;
}

.chart-bar:nth-child(1) { animation-delay: 0.1s; }
.chart-bar:nth-child(2) { animation-delay: 0.2s; }
.chart-bar:nth-child(3) { animation-delay: 0.3s; }
.chart-bar:nth-child(4) { animation-delay: 0.4s; }
.chart-bar:nth-child(5) { animation-delay: 0.5s; }

@keyframes chartGrow {
  from { height: 0; }
  to { height: var(--height, 50%); }
}

.metric-progress {
  display: flex;
  justify-content: center;
  align-items: center;
}

.progress-ring {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-circle {
  transition: stroke-dashoffset 1s ease-in-out;
  stroke-linecap: round;
}

.progress-text {
  position: absolute;
  font-size: 14px;
  font-weight: 700;
  color: white;
}

.progress-bar-modern {
  width: 100%;
  height: 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.progress-fill-modern {
  height: 100%;
  border-radius: 4px;
  position: relative;
  transition: width 1s ease-in-out;
}

.progress-shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.donut-chart {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.donut-text {
  position: absolute;
  font-size: 14px;
  font-weight: 700;
  color: white;
}


/* Filtros */
.filters-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px 24px;
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  width: 100%;
}

.filters-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  width: 20px;
  height: 20px;
  color: var(--text-muted);
  z-index: 1;
}

.search-input {
  padding: 10px 12px 10px 40px;
  background-color: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 14px;
  width: 300px;
  transition: all 0.2s ease;
}

.search-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(88, 101, 242, 0.1);
}

.sort-select {
  padding: 10px 12px;
  background-color: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 14px;
  cursor: pointer;
}

.filters-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.view-toggle {
  display: flex;
  background-color: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  overflow: hidden;
}

.view-btn {
  padding: 8px 12px;
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-btn.active {
  background-color: var(--primary);
  color: white;
}

/* Loading */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px;
  color: var(--text-secondary);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--border-primary);
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Grid View */
.workspaces-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
  width: 100%;
  padding: 0 24px;
}

.workspace-card {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-primary) 100%);
  border: 1px solid var(--border-primary);
  border-radius: 20px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.workspace-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--primary) 0%, var(--primary-dark) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.workspace-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border-color: var(--primary);
}

.workspace-card:hover::before {
  opacity: 1;
}

/* Card Header Premium */
.card-header-premium {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
}

.workspace-identity {
  display: flex;
  align-items: center;
  gap: 12px;
}

.workspace-avatar {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.workspace-avatar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%);
  border-radius: 16px;
}

.avatar-icon {
  font-size: 20px;
  color: white;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
  z-index: 1;
  position: relative;
}

.workspace-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.workspace-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.2;
}

.workspace-badge {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  background: rgba(255, 255, 255, 0.1);
  padding: 2px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.edit-btn-premium {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.edit-btn-premium:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Score Metrics Premium */
.score-metrics-premium {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.metric-primary {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.metric-value-large {
  font-size: 32px;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1;
  background: linear-gradient(135deg, var(--text-primary) 0%, var(--text-muted) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-label-large {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metric-secondary {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.metric-value-small {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1;
}

.metric-label-small {
  font-size: 10px;
  font-weight: 500;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Progress Ring */
.progress-ring-section {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.progress-ring-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-ring {
  transform: rotate(-90deg);
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.progress-circle {
  transition: stroke-dashoffset 1s ease-in-out;
  stroke-linecap: round;
}

.progress-text {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.progress-percentage {
  font-size: 16px;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1;
}

.progress-label {
  font-size: 10px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Bonificações Premium */
.bonus-section-premium {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.bonus-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.bonus-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bonus-total {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
}

.bonus-grid-premium {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bonus-item-premium {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease;
}

.bonus-item-premium:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateX(2px);
}

.bonus-item-premium.positive {
  border-left: 3px solid #10b981;
}

.bonus-item-premium.negative {
  border-left: 3px solid #ef4444;
}

.bonus-icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  flex-shrink: 0;
}

.bonus-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}

.bonus-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-muted);
}

.bonus-value {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
}

.bonus-item-premium.positive .bonus-value {
  color: #10b981;
}

.bonus-item-premium.negative .bonus-value {
  color: #ef4444;
}

.workspace-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.workspace-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: white;
  font-weight: 600;
}

.workspace-details {
  flex: 1;
}

.workspace-name {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 4px 0;
}

.workspace-type {
  font-size: 12px;
  color: var(--text-muted);
  background-color: var(--bg-primary);
  padding: 2px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  font-weight: 500;
}

.card-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn.edit {
  background-color: var(--info);
  color: white;
}

.action-btn.edit:hover {
  background-color: var(--info-dark);
  transform: scale(1.1);
}

/* Score Section */
.score-section {
  margin-bottom: 20px;
}

.score-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.score-row:has(.score-item:only-child) {
  justify-content: center;
}

.score-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.score-label {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 4px;
  text-transform: uppercase;
  font-weight: 500;
}

.score-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}

.score-value.meta {
  color: var(--warning);
}

.score-value.total {
  color: var(--primary);
}

.score-value.percentage.success {
  color: var(--success);
}

.score-value.percentage.warning {
  color: var(--warning);
}

.score-value.percentage.danger {
  color: var(--danger);
}

/* Progress Section */
.progress-section {
  margin-bottom: 20px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background-color: var(--bg-primary);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 4px;
}

.progress-text {
  font-size: 12px;
  color: var(--text-muted);
  text-align: center;
}

/* Bonus Section */
.bonus-section {
  border-top: 1px solid var(--border-primary);
  padding-top: 16px;
}

.bonus-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.bonus-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.bonus-label {
  font-size: 10px;
  color: var(--text-muted);
  margin-bottom: 4px;
  text-transform: uppercase;
  font-weight: 500;
}

.bonus-value {
  font-size: 14px;
  font-weight: 600;
}

.bonus-value.positive {
  color: var(--success);
}

.bonus-value.negative {
  color: var(--danger);
}

.bonus-value.neutral {
  color: var(--text-muted);
}

/* List View */
.workspaces-list {
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  overflow: hidden;
}

.list-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 2fr 80px;
  gap: 16px;
  padding: 16px 20px;
  background-color: var(--bg-primary);
  border-bottom: 1px solid var(--border-primary);
  font-weight: 600;
  color: var(--text-primary);
  font-size: 14px;
}

.list-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 2fr 80px;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-primary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.list-row:hover {
  background-color: var(--bg-hover);
}

.list-row:last-child {
  border-bottom: none;
}

.list-col {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.list-col.name .workspace-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.list-col.name .workspace-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: white;
  font-weight: 600;
}

.list-col.name .workspace-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.list-col.name .workspace-type {
  font-size: 11px;
  color: var(--text-muted);
  text-transform: uppercase;
  font-weight: 500;
}

.bonus-mini {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  color: var(--text-muted);
}

/* Responsive */
@media (max-width: 768px) {
  .all-workspaces-page {
    padding: 0;
  }
  
  .header-container {
    padding: 0 16px;
  }
  
  .metrics-grid-compact,
  .workspace-metrics-grid,
  .workspaces-grid {
    padding: 0 16px;
  }
  
  .filters-section {
    padding: 16px;
  }
  
  .title-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .actions-section {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    width: 100%;
  }
  
  .view-toggles {
    align-self: center;
  }
  
  .main-title {
    font-size: 24px;
  }
  
  .subtitle {
    font-size: 14px;
  }
  
  .metrics-grid-compact {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .workspace-metrics-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .workspace-metric-card {
    padding: 20px;
  }
  
  .metric-card-compact {
    padding: 16px;
  }
  
  .metric-value-compact {
    font-size: 24px;
  }
  
  .metric-icon-compact {
    width: 36px;
    height: 36px;
  }
  
  .metric-insights-compact {
    min-width: 70px;
    padding: 4px;
    gap: 3px;
  }
  
  .insight-compact {
    font-size: 8px;
    padding: 1px 0;
  }
  
  .insight-value {
    font-size: 8px;
  }
  
  .insight-label {
    font-size: 7px;
  }
  
  .insight-compact.positive,
  .insight-compact.negative {
    padding-left: 3px;
  }
  
  .meta-progress-content {
    flex-direction: column;
    gap: 16px;
  }
  
  .progress-ring-large {
    align-self: center;
  }
  
  .meta-details {
    width: 100%;
  }
  
  .meta-detail-item {
    padding: 10px 12px;
  }
  
  .detail-icon {
    width: 28px;
    height: 28px;
  }
  
  .detail-value {
    font-size: 14px;
  }
  
  
  .filters-section {
    flex-direction: column;
    gap: 16px;
  }
  
  .filters-left {
    flex-direction: column;
    align-items: stretch;
  }
  
  .search-input {
    width: 100%;
  }
  
  .workspaces-grid {
    grid-template-columns: 1fr;
  }
  
  .workspace-card {
    padding: 20px;
  }
  
  .workspace-avatar {
    width: 40px;
    height: 40px;
  }
  
  .avatar-icon {
    font-size: 16px;
  }
  
  .avatar-image {
    border-radius: 12px;
  }
  
  .workspace-title {
    font-size: 16px;
  }
  
  .score-metrics-premium {
    padding: 16px;
    margin-bottom: 20px;
  }
  
  .metric-value-large {
    font-size: 28px;
  }
  
  .metric-value-small {
    font-size: 16px;
  }
  
  .progress-ring {
    width: 60px;
    height: 60px;
  }
  
  .progress-percentage {
    font-size: 14px;
  }
  
  .bonus-section-premium {
    padding: 12px;
  }
  
  .bonus-item-premium {
    padding: 6px;
  }
  
  .bonus-icon {
    width: 20px;
    height: 20px;
  }
  
  .list-header,
  .list-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .list-header {
    grid-template-columns: 1fr;
  }
  
  .list-row {
    grid-template-columns: 1fr;
  }
  
  .list-col {
    justify-content: space-between;
  }
  
  .list-col::before {
    content: attr(data-label);
    font-weight: 600;
    color: var(--text-muted);
  }
}

/* Modal de Meta Geral */
.modal-overlay {
  @apply fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50;
}

.modal-content {
  @apply bg-white rounded-lg shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto;
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-primary);
}

.modal-header {
  @apply flex justify-between items-center p-6 border-b border-gray-200;
  border-bottom: 1px solid var(--border-primary);
}

.modal-title {
  @apply text-xl font-semibold text-gray-900;
  color: var(--text-primary);
  margin: 0;
}

.modal-close {
  @apply text-gray-400 hover:text-gray-600 transition-colors;
  color: var(--text-muted);
}

.modal-close:hover {
  color: var(--text-primary);
}

.modal-form {
  @apply p-6 space-y-6;
}

.form-group {
  @apply space-y-2;
}

.form-label {
  @apply block text-sm font-medium text-gray-700;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  background-color: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  color: var(--text-primary);
  transition: all 0.2s ease;
  font-size: 14px;
}

.form-input::placeholder {
  color: var(--text-muted);
}

.form-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(88, 101, 242, 0.1);
  transform: translateY(-1px);
}

.form-input:hover {
  border-color: var(--border-hover);
  background-color: var(--bg-hover);
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-help {
  font-size: 12px;
  color: var(--text-muted);
  font-style: italic;
}

.preview-section {
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 20px;
  background-color: var(--bg-primary);
}

.section-title {
  @apply text-lg font-semibold text-gray-900;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px 0;
}

.preview-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

.preview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.preview-label {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 4px;
  text-transform: uppercase;
  font-weight: 500;
}

.preview-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}

.preview-value.meta {
  color: var(--warning);
}

.preview-value.percentage.success {
  color: var(--success);
}

.preview-value.percentage.warning {
  color: var(--warning);
}

.preview-value.percentage.danger {
  color: var(--danger);
}

.progress-section {
  margin-top: 20px;
}

.progress-bar {
  width: 100%;
  height: 12px;
  background-color: var(--bg-secondary);
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 6px;
}

.progress-text {
  font-size: 12px;
  color: var(--text-muted);
  text-align: center;
}

.modal-actions {
  @apply flex justify-end gap-3 pt-4 border-t border-gray-200;
  border-top: 1px solid var(--border-primary);
}

.btn-secondary {
  @apply px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
}

.btn-secondary:hover {
  background-color: var(--bg-hover);
  border-color: var(--border-hover);
}

.btn-primary {
  @apply px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-md transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed;
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(88, 101, 242, 0.4);
}

.loading-spinner {
  @apply w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin;
}
</style>